import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { SearchBox } from "@components";
import { TableColumn } from "./TableColumn";

import { TablePagination } from "@helpers/tablePagination";

// import { RETIREMENT_STATUS } from "@constants/status.hrm";
import { useFileInquiry } from "@hooks/HRM/employee/useFileInquiry";

// const { DRAFT, IN_PROGRESS, APPROVED, ACTION_NEEDED } = RETIREMENT_STATUS;

export const ReleaseListTable = () => {
  // const [activeStatus, setActiveStatus] = useState(0);

  const { control } = useForm();
  const { t } = useTranslation();
  const { handleQuery, fileInquiryList } = useFileInquiry(null);

  // const btnGroupAction = (index: number) => {
  //   let statusId = null;
  //   setActiveStatus(index);

  //   switch (index) {
  //     case 0:
  //       statusId = null;
  //       break;
  //     case 1:
  //       statusId = DRAFT;
  //       break;
  //     case 2:
  //       statusId = IN_PROGRESS;
  //       break;
  //     case 3:
  //       statusId = APPROVED;
  //       break;
  //     case 4:
  //       statusId = ACTION_NEEDED;
  //       break;
  //     default:
  //       statusId = null;
  //       break;
  //   }
  //   handleQuery("status", statusId);
  // };

  return (
    <div>
      <Table
        header={{
          title: t("FILE_INQUIRY_LIST.TABLE.HEADER"),
          badge: {
            label: `${fileInquiryList?.total || 0}`,
            size: "sm",
            type: "primary",
          },
        }}
        headerExtension={{
          rightComponents: [
            <SearchBox
              key="search"
              control={control}
              handleQuery={handleQuery}
            />,
          ],
        }}
        columns={TableColumn(t)}
        rows={fileInquiryList?.data || []}
        pagination={TablePagination(
          {
            page: fileInquiryList?.page || 1,
            size: fileInquiryList?.size || 10,
            total: fileInquiryList?.total || 0,
          },
          handleQuery,
        )}
      />
    </div>
  );
};
